import React from 'react'
import cbModal from '../../../Modal/Modal';
import ImageModal from '../../components/ModalComponent'
import { ChooseAssetModalProps, GetAssets, GetUsers } from '../../types';
import { getAssets as getAssetsUsingSdk, getUsers as getUsersUsingSdk } from '../../commons/request';

type OpenChooseAssetModalUseSdk = {
  /**
   * App SDK (for extensions)
   */
  sdk: any;
  getAssets?: never;
  getUsers?: never;
}

type OpenChooseAssetModalUsingGetters = {
  /**
   * Async function to fetch assets
   */
  getAssets: GetAssets;
  /**
   * Async function to fetch users
   */
  getUsers: GetUsers;
  sdk?: never;
}

export type OpenChooseAssetModalOptions = Omit<ChooseAssetModalProps, "getAssets" | "getUsers" | "closeModal">
  & (OpenChooseAssetModalUseSdk | OpenChooseAssetModalUsingGetters);

/**
 * Function to open the asset "picker" modal which allows selection of
 * assets fetched using the `getAssets` function or the `sdk` in `args`
 * 
 * Note: File type validation (`args.only`) and uid exclusion should be handled in the
 * `getAssets` function if one is provided.
 * @param args {OpenChooseAssetModalOptions}
 */
export const openChooseAssetModal = (args: OpenChooseAssetModalOptions) => {
  const contentstackSDK = args.sdk;

  // use fetch functions or sdk  
  const getAssets = args.getAssets ?? (contentstackSDK && getAssetsUsingSdk);
  const getUsers = args.getUsers ?? (contentstackSDK && getUsersUsingSdk);

  // if any function is still missing, throw error
  // If showUserDataColumn is in args & if it is false & getAssets only provided, skipping throw err
  const gettersMissing = (!getAssets || !getUsers) && !('showUserDataColumn' in args && !args.showUserDataColumn && getAssets && !getUsers);

  if (gettersMissing) {
    throw new Error(
      `openChooseAssetModal (required props missing): "sdk", functions - "getAssets" and "getUsers".
      Needs "sdk" or all functions. Optionally, only some functions can also be provided along WITH sdk.`
    )
  }

  if ("sdk" in args) {
    // SDK mode
    window.contentstackSDK = contentstackSDK
    window.postRobot = contentstackSDK.postRobot
  }

  if (!args.onSubmit) throw new Error("onSubmit is required argument")

  cbModal({
    component: (extraProps: any) =>
      <ImageModal
        {...args}
        showUserDataColumn={'showUserDataColumn' in args ? args.showUserDataColumn : true}
        showCTAIcon={'showCTAIcon' in args ? args.showCTAIcon : true}
        getAssets={getAssets}
        getUsers={getUsers}
        {...extraProps}
        closeModal={() => {
          extraProps?.closeModal()
          if (args.onCancel) {
            args.onCancel()
          }
        }}
      />,
    modalProps: {
      size: 'max',
      customClass: 'reference__modal'
    },
  })
}